import { logger } from '@tinkoff/logger';

import { getSentryReporter } from '@breeze/web-lib-sentry';
import { enrichSentryRequestError } from '@breezeventures/web-lib-ph-request/utils';

logger.setLevel('info');
logger.addReporter(
  getSentryReporter({
    onRequestError: enrichSentryRequestError,
  })
);

export { logger } from '@tinkoff/logger';
